const formatPercentage = value => `${(value * 100).toFixed(0)}%`;

const round = value => {
  const precision = Math.min(
    Math.max(Math.floor(Math.log10(Math.abs(value))), 1),
    3
  );

  return parseFloat(value.toPrecision(precision)).toLocaleString();
};

export const formatValue = (value, percentage, na = "n/a") =>
  isNaN(value) ? na : !percentage ? round(value) : formatPercentage(value);

export const getGniGroupCode = gniGroup =>
  ({
    "Low-Income (LIC)": "LIC",
    "Lower-Middle-Income (L-MIC)": "L-MIC",
    "Upper-Middle-Income (U-MIC)": "U-MIC"
  }[gniGroup] || gniGroup);

export const getMarker = color =>
  `<svg height="11" width="11"> <circle cx="6" cy="6" r="4" stroke="black" stroke-width="1" fill="${color}" /></svg>`;

export const getNewLine = () =>
  navigator.platform === "Win32" ? "\r\n" : "\n";

export const downloadCsv = (csv, filename) => {
  const link = document.createElement("a");

  link.href = "data:text/csv," + escape(csv);
  link.download = filename;

  link.click();
};

export const isIE = () => /*@cc_on!@*/ false || !!document.documentMode;